interface ContactFormData {
  name: string;
  phone: string;
  comment: string;
}

interface ApiResponse {
  success: boolean;
  message?: string;
  error?: string;
}

// const API_KEY = process.env.REACT_APP_API_KEY;
// const BASE_URL = process.env.REACT_APP_BASE_URL;

export const sendContactForm = async (formData: ContactFormData): Promise<ApiResponse> => {
  try {
    const response = await fetch("/gateway/api/v1/Public/BydContact", {
      method: 'POST',
      headers: new Headers({
        "Content-Type": "application/json;charset=UTF-8",
        "ApiKey": process.env.REACT_APP_API_KEY || ''
      }),
      body: JSON.stringify({
        data: {
          name: formData.name,
          phone: formData.phone,
          message: formData.comment,
        }
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // const data = await response.json();
    
    return {
      success: true,
      message: '', // Сообщение будет взято из переводов в компоненте
    };
  } catch (error) {
    console.error('Error sending contact form:', error);
    
    return {
      success: false,
      error: error instanceof Error ? error.message : '',
    };
  }
}; 